import './styles.scss';

import { useTranslation } from 'react-i18next';
import { Text } from '@fragments';
import {
    IconBuildingBank,
    IconSparkles,
    IconChartLine,
    IconInfoCircle
} from '@tabler/icons-react';
import { useLocation } from 'react-router-dom';
import SidebarItem from '../_components/SidebarItem';
import CreatorMentoringItem from './CreatorMentoringItem';
import config from '@config';

export default function AdminSection() {
    const { t } = useTranslation('shell');
    const location = useLocation();

    return (
        <div className="cs-admin-section">
            <div className="cs-sidebar-section-title">
                <Text.h6
                    contrast={6}
                    grow
                    weight={400}
                    className="mb-1 pl-1 mt-1"
                >
                    {t('sidebar.administration')}
                </Text.h6>
            </div>

            <div className="admin-list">
                <SidebarItem
                    text="Studio"
                    left={<IconSparkles size={20} />}
                    onClick={() => window.navigate("/studio")}
                    active={location.pathname.startsWith("/studio")}
                />
                <SidebarItem
                    text={t('sidebar.banking')}
                    left={<IconBuildingBank size={20} />}
                    onClick={() => window.navigate("/banking/charges")}
                    active={location.pathname.includes("/banking")}
                />
                <CreatorMentoringItem />
                <SidebarItem
                    text={t('sidebar.insights')}
                    left={<IconChartLine size={20} />}
                    onClick={() => window.navigate("/insights")}
                    active={location.pathname.includes("/insights")}
                />
                <SidebarItem
                    text={t('sidebar.support')}
                    left={<IconInfoCircle size={20} />}
                    onClick={() => window.open(config.help)}
                    active={location.pathname.includes("/support")}
                />
            </div>
        </div>
    )
}
